import { postText, requireUrl } from "../http.js";

function buildCaptionUrl(endpoint, seq) {
    const url = new URL(requireUrl(endpoint, "YouTube ingestion URL"));
    url.searchParams.set("seq", seq);

    return url.toString();
}

function buildYouTubeTimestamp(latencyOffset = 0) {
    // YouTube's vendor examples use UTC ISO time without a trailing timezone marker.
    return new Date(Date.now() + Number(latencyOffset) * 1000).toISOString().replace("Z", "");
}

function formatCaptionText(text = "") {
    // YouTube uses newlines to split timestamp/text records; caption line breaks must be encoded.
    const captionText = String(text).replace(/\r\n|\r|\n/g, "<br>");
    return captionText.endsWith("<br>") ? captionText : `${captionText}<br>`;
}

function getYouTubeRegion(config) {
    const region = Number(config.youtubeRegion) || 8;
    return Math.min(9, Math.max(1, region));
}

function getRollupRows(config) {
    const rows = Number(config.rows) || 1;
    return Math.min(4, Math.max(1, rows));
}

function buildCaptionPacket(lines = [], config = {}, seq = 1) {
    const region = getYouTubeRegion(config);
    const captionText = lines.map(line => formatCaptionText(line)).join("");
    return `${buildYouTubeTimestamp(config.latencyOffset)} region:reg${region}#cue${seq}\n${captionText}\n`;
}

export function createYouTubeAdapter(config) {
    let rollupHistory = [];

    return {
        async connect() {
            requireUrl(config.endpoint, "YouTube ingestion URL");
            return true;
        },
        async test(ctx = {}) {
            return this.send("", ctx);
        },
        async send(text = "", ctx = {}) {
            const seq = ctx.seq ?? 1;
            const url = buildCaptionUrl(config.endpoint, seq);

            if (text) {
                rollupHistory.push(text);

                while (rollupHistory.length > getRollupRows(config)) {
                    rollupHistory.shift();
                }
            } else {
                rollupHistory = [];
            }

            return postText(
                url,
                text ? buildCaptionPacket(rollupHistory, config, seq) : "",
                { contentType: "text/plain" },
                true,
            );
        },
        async clear(ctx = {}) {
            return this.send("", ctx);
        },
        async disconnect() {
            return true;
        },
    };
}
